import { defineMessages } from 'react-intl';

const translations = {
  sections: {
    cache: {
      id: 'proxyForm.sections.cache',
      defaultMessage: 'Cache',
      description: 'label of the form field section cache',
    },
    auth: {
      id: 'proxyForm.sections.auth',
      defaultMessage: 'Authentication',
      description: 'label of the form field section auth',
    },
    oauth: {
      id: 'proxyForm.sections.oauth',
      defaultMessage: 'oAuth',
      description: 'label of the form field section auth',
    },
  },
  fields: {
    key: {
      label: {
        id: 'properties.key',
        defaultMessage: 'Key',
        description: 'label of the form field key',
      },
    },
    uri: {
      label: {
        id: 'properties.uri',
        defaultMessage: 'URI',
        description: 'label of the form field uri',
      },
    },
    secret: {
      label: {
        id: 'properties.secret',
        defaultMessage: 'Secret',
        description: 'label of the form field secret',
      },
    },
    isBucket: {
      label: {
        id: 'properties.isBucket',
        defaultMessage: 'Bucket',
        description: 'label of the form field is bucket',
      },
    },
    isAsOrigin: {
      label: {
        id: 'properties.isAsOrigin',
        defaultMessage: 'As origin',
        description: 'label of the form field is as origin',
      },
    },
    isPublic: {
      label: {
        id: 'properties.isPublic',
        defaultMessage: 'Public',
        description: 'label of the form field is public',
      },
    },
    age: {
      label: {
        id: 'properties.age',
        defaultMessage: 'Age',
        description: 'label of the form field age',
      },
    },
    isRequired: {
      label: {
        id: 'properties.isRequired',
        defaultMessage: 'Required',
        description: 'label of the form field is required',
      },
    },
    scope: {
      label: {
        id: 'properties.scope',
        defaultMessage: 'Scope',
        description: 'label of the form field scope',
      },
    },
    issuer: {
      label: {
        id: 'properties.issuer',
        defaultMessage: 'Issuer',
        description: 'label of the form field issuer',
      },
    },
    clientId: {
      label: {
        id: 'properties.clientId',
        defaultMessage: 'Client',
        description: 'label of the form field client id',
      },
    },
    authorizeUrl: {
      label: {
        id: 'properties.authorizeUrl',
        defaultMessage: 'Authorize url',
        description: 'label of the form field authorize url',
      },
    },
    returnUrlKey: {
      label: {
        id: 'properties.returnUrlKey',
        defaultMessage: 'Return url key',
        description: 'label of the form field return url key',
      },
    },
  },
};

export default defineMessages(translations);
